import { Cookie, Header } from "~/types";
import {
  defaultHeaders,
  fetchClientConfig,
  fetchV4Home,
  SendOTPResult,
  sendPartnerOTPViaSMS,
  setAuth,
  setDefaultHeaders,
  SubmitOTPResult,
  submitPartnerOTP,
} from "../auth";
import { EventManager, HubbleEvent } from "../events";
import { setCookie } from "~/utils/client_cookie";
import { config } from "../config";
import { HubbleOTPAuth } from "~/screens/hubble_otp_auth/hubble_otp_auth";
import { HubbleRoute, pushPage } from "~/shared_states/modal";

export function logIntoPartnerSdkViaPhoneNumber(
  afterLogin: () => void,
  eventManager: EventManager
) {
  const onPhoneSubmit = async (phoneNumber: string): Promise<SendOTPResult> => {
    return sendPartnerOTPViaSMS(phoneNumber);
  };

  const onOtpSubmit = async (
    phoneNumber: string,
    otp: string,
    otpToken: string
  ): Promise<SubmitOTPResult> => {
    return submitPartnerOTP(phoneNumber, otp, otpToken);
  };

  const onResendOtp = async (phoneNumber: string): Promise<SendOTPResult> => {
    return sendPartnerOTPViaSMS(phoneNumber);
  };

  const onOtpSuccess = async (
    phoneNumber: string,
    submitResult: SubmitOTPResult
  ): Promise<void> => {
    // Partner SDK specific login logic will go here
    // For now, using the same logic as Hubble login

    eventManager.sendEvent(HubbleEvent.LOGIN, {
      phoneNumber: phoneNumber,
    });

    setDefaultHeaders({
      ...defaultHeaders(),
      [Header.SessionId]: submitResult.sessionId,
    });

    setAuth(() => {
      return { sessionId: submitResult.sessionId } as any;
    });

    setCookie({
      key: Cookie.SessionId,
      value: submitResult.sessionId,
      expiryInMinutes: config.sesssionDurationInMinutes.webstore,
    });
    afterLogin();
  };

  pushPage(
    () => (
      <HubbleOTPAuth
        onPhoneSubmit={onPhoneSubmit}
        onOtpSubmit={onOtpSubmit}
        onResendOtp={onResendOtp}
        onOtpSuccess={onOtpSuccess}
        eventManager={eventManager}
        mode="sdk"
      />
    ),
    {
      isModal: true,
      disableCloseButton: true,
    },
    HubbleRoute.COLLECT_PHONE
  );
}
